import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Sparkles, Send, Loader2, Bot } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Markdown } from "./Markdown";

export function AiAssistant() {
  const [insights, setInsights] = useState(null);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState(null);

  const insightsMut = useMutation({
    mutationFn: async () => (await api.get("/ai/insights")).data,
    onSuccess: (d) => setInsights(d.insights),
    onError: (e) => setInsights(e.response?.data?.detail || "Could not generate insights right now."),
  });

  const askMut = useMutation({
    mutationFn: async (q) => (await api.post("/ai/ask", { question: q })).data,
    onSuccess: (d) => setAnswer(d.answer),
    onError: (e) => setAnswer(e.response?.data?.detail || "Could not answer right now."),
  });

  const ask = () => {
    if (!question.trim()) return;
    setAnswer(null);
    askMut.mutate(question.trim());
  };

  return (
    <div className="rounded-3xl border border-primary/30 bg-gradient-to-br from-primary/10 to-transparent p-5" data-testid="ai-assistant-card">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-heading font-bold flex items-center gap-2"><Sparkles className="h-4 w-4 text-primary" /> AI assistant</h2>
        <Button size="sm" variant="outline" className="rounded-full bg-card" onClick={() => insightsMut.mutate()} disabled={insightsMut.isPending} data-testid="ai-insights-btn">
          {insightsMut.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : "Monthly insights"}
        </Button>
      </div>

      {insights && (
        <div className="rounded-2xl bg-card border border-border p-3.5 mb-3" data-testid="ai-insights-output">
          <Markdown>{insights}</Markdown>
        </div>
      )}

      <div className="flex gap-2">
        <Input value={question} onChange={(e) => setQuestion(e.target.value)} onKeyDown={(e) => e.key === "Enter" && ask()} placeholder="Ask about your expenses…" className="h-11 rounded-xl bg-card" data-testid="ai-ask-input" />
        <Button onClick={ask} disabled={askMut.isPending} className="h-11 rounded-xl shrink-0" data-testid="ai-ask-btn">
          {askMut.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        </Button>
      </div>

      {answer && (
        <div className="mt-3 flex items-start gap-2.5" data-testid="ai-answer-output">
          <div className="h-8 w-8 shrink-0 rounded-xl bg-primary/15 text-primary flex items-center justify-center"><Bot className="h-4 w-4" /></div>
          <div className="rounded-2xl bg-card border border-border p-3.5 flex-1"><Markdown>{answer}</Markdown></div>
        </div>
      )}
    </div>
  );
}
